import React from 'react'
import cx from 'classnames'
import styles from '../Modal.module.scss'
import { Button, DynamicIcon, Heading, Paragraph } from '~elements'
import { ButtonProps, ModalViewFormSubmitProps } from '~types'
import { getGtmLinkPosition } from '~analyticsUtils'

const ModalViewFormSubmit = ({ view, handleModalClose, isBelowSm, isErrorView = false }: ModalViewFormSubmitProps) => {
  const { ctas, description, iconName = 'celebration', title } = view || {}

  return (
    <>
      {iconName && (
        <div
          className={cx(styles['modal-icon-wrapper'], {
            [styles['modal-icon-wrapper--error']]: isErrorView
          })}
        >
          <DynamicIcon name={iconName} />
        </div>
      )}
      <Heading level={3} justify='center' noMarginTop>
        {title}
      </Heading>
      <Paragraph text={description} fontSize={isBelowSm ? 'sm' : 'md-plus'} justify='center' />
      {ctas && ctas.length > 0 && (
        <div className={styles['modal-cta-buttons']}>
          {ctas.map((cta: ButtonProps, index: number) => (
            <Button
              key={cta.id}
              {...cta}
              {...(isBelowSm && { isFullWidth: true })}
              {...(isErrorView && { onClick: () => handleModalClose() })}
              analytics={{
                linkModule: `modal_form_submit`,
                linkPosition: getGtmLinkPosition(ctas, index)
              }}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default ModalViewFormSubmit
